import { AdvancingTemplateDetailSection } from "../AdvancingTemplateDetailSection";
import AdvancingTemplateOptionsPanel from "../AdvancingTemplateOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";

const AdvancingTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.AdvancingTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <AdvancingTemplateDetailSection
            advancingTemplate={viewModel.advancingTemplate}
            formGroups={viewModel.formGroups}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <AdvancingTemplateOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            advancingTemplateId={viewModel.advancingTemplate.advancingTemplateId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default AdvancingTemplateDetailApp;